import * as S from './styles'
import { useFormContainer } from './useFormContainer'
import { Input, SelectInput } from '@/components'
import { Button } from '@/components/button'
import { useInputValidation } from '@/hooks/useInputValidation'
import { validateEmail } from '@/utils/validations'

export type FormContainerProps = {
  nameInputLabel: string
  nameInputPlaceholder: string
  emailInputLabel: string
  emailInputPlaceholder: string
  companyInputLabel: string
  companyInputPlaceholder: string
  companySegmentInputLabel: string
  segmentOptions: { value: string; id: string }[]
  buttonText: string
  buttonTextSuccess: string
}

export const FormContainer: React.FC<FormContainerProps> = ({
  nameInputLabel,
  nameInputPlaceholder,
  emailInputLabel,
  emailInputPlaceholder,
  companyInputLabel,
  companyInputPlaceholder,
  companySegmentInputLabel,
  segmentOptions,
  buttonText,
  buttonTextSuccess,
}) => {
  const { handleErrorMessage, handleBlur } = useInputValidation()
  const {
    submitted,
    form,
    onChange,
    setForm,
    isExistErrors,
    handleSubmitForm,
  } = useFormContainer({ handleErrorMessage })

  return (
    <S.FormContainer
      id="lp-form-container"
      name="Quero um time nata.house - Landing Page"
      disabled={isExistErrors}
      onSubmit={handleSubmitForm}
    >
      <Input
        placeholder={nameInputPlaceholder}
        value={form?.name}
        label={nameInputLabel}
        name="name"
        onChange={(e) => onChange(e)}
        type="text"
        className="input-form"
        onBlur={() => handleBlur('name')}
        error={handleErrorMessage('name', form.name)}
      />
      <Input
        placeholder={emailInputPlaceholder}
        value={form?.email}
        label={emailInputLabel}
        name="email"
        onChange={(e) => onChange(e)}
        type="text"
        className="input-form"
        onBlur={() => handleBlur('email')}
        error={handleErrorMessage(
          'email',
          form.email,
          validateEmail,
          'E-mail inválido',
        )}
      />
      <Input
        placeholder={companyInputPlaceholder}
        value={form?.company}
        label={companyInputLabel}
        name="company"
        onChange={(e) => onChange(e)}
        type="text"
        className="input-form"
        onBlur={() => handleBlur('company')}
        error={handleErrorMessage('company', form.company)}
      />
      <SelectInput
        label={companySegmentInputLabel}
        name="segment"
        onChange={(e) => setForm({ ...form, segment: e })}
        options={segmentOptions}
        value={form.segment}
        onBlur={() => handleBlur('segment')}
        error={handleErrorMessage('segment', form.segment)}
      />
      <Button
        className="button-container"
        type="submit"
        disabled={isExistErrors || submitted}
      >
        {submitted ? buttonTextSuccess : buttonText}
      </Button>
    </S.FormContainer>
  )
}
